import t from "./_baseGet.js";
function o(e) {
  return function(r) {
    return t(r, e);
  };
}
export {
  o as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_basePropertyDeep.js
// module id = 1488
// module chunks = 67